import(/* webpackMode: "eager" */ "/root/elawphant/src/app/[locale]/gotovye-ooo/page.tsx");
